import { render, staticRenderFns } from "./BtnExcluirComprometimento.vue?vue&type=template&id=1b91d8aa"
import script from "./BtnExcluirComprometimento.vue?vue&type=script&lang=js"
export * from "./BtnExcluirComprometimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports